/**
 * ハンバーガーメニュー: .js-hamburger クリックで .topNav__inner を開閉
 */
export function init() {
	if (typeof window.$ === 'undefined') return;
	const $ = window.$;
	const $btn = $('.js-hamburger');
	const $inner = $('.topNav__inner');
	if (!$btn.length || !$inner.length) return;

	const $overlay = $('<div class="js-hamburger-overlay l-hamburger-overlay" style="display:none;position:fixed;inset:0;z-index:249;"></div>');
	$('body').append($overlay);

	function openNav() {
		$inner.removeClass('is-closing').addClass('is-open');
		$overlay.fadeIn(200);
		$btn.attr('aria-expanded', 'true');
		$btn.addClass('is-open');
	}

	function closeNav() {
		$inner.addClass('is-closing').removeClass('is-open');
		$overlay.fadeOut(350);
		$btn.attr('aria-expanded', 'false');
		$btn.removeClass('is-open');
		$inner.one('transitionend', function () {
			$inner.removeClass('is-closing');
		});
	}

	$btn.on('click', function () {
		if ($inner.hasClass('is-open')) closeNav();
		else openNav();
	});
	$overlay.on('click', closeNav);
	// ナビ内リンククリックで閉じる（同一ページアンカーでも確実に閉じる）
	$inner.on('click', 'a[href]', function () {
		if ($inner.hasClass('is-open')) closeNav();
	});
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && $inner.hasClass('is-open')) closeNav();
	});
}
